import {
    Typography,
} from "@mui/material";
import { LoginStatuses } from "../../constants";

const AUTOMATIC_LOGIN_ISSUE_MESSAGE =
    "Your login flow couldn't be recognized automatically. Please provide a few details to help us investigate.";

const LoginStatus = ({ status, stage }) => {
    let statusMessage = '';
    switch (status) {
        case LoginStatuses.failed:
            statusMessage = stage === 4
                ? 'Login failed'
                : AUTOMATIC_LOGIN_ISSUE_MESSAGE
            break;
        case LoginStatuses.bot_protection:
            statusMessage = stage === 4
                ? 'Login failed'
                : AUTOMATIC_LOGIN_ISSUE_MESSAGE
            break;
        case LoginStatuses.completed:
            statusMessage = 'Login successful!'
            break;
        case LoginStatuses.pending:
        case LoginStatuses.running:
        default:
            statusMessage = 'Login Processing...';
            break;
    }
    return <Typography className="loginTabTitle">
        {statusMessage}
    </Typography>
}


export default LoginStatus;
